/**
 * Product image URLs.
 *
 * Products reach the UI in two shapes:
 *   - `media` (REST): `{ square: { type, value }, thumbnail: { type, value } }`
 *   - `images` (GraphQL and the order/cart types): `[{ square: url, thumbnail: url }]`
 *
 * Both resolve the same way: square photo, then thumbnail, then the default
 * product image.
 */

import type { ProductMedia } from '~/api/generated/types.gen';
import defaultProductImage from '~/assets/images/marketing/default-product-image.svg';
import type { ProductImages } from '~/types/product';

function firstImageUrl(...urls: unknown[]): string {
  return (
    urls.find((url): url is string => typeof url === 'string' && url !== '') ?? defaultProductImage
  );
}

export function productImageFromMedia(media: ProductMedia | null | undefined): string {
  return firstImageUrl(media?.square?.value, media?.thumbnail?.value);
}

export function productImageFromImages(images: ProductImages[] | null | undefined): string {
  const [first] = images ?? [];
  return firstImageUrl(first?.square, first?.thumbnail);
}
